import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../_virtual/_tslib.js';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { styled, Stack, useUtility, Container, Text, Button } from '@hub-la/design-system';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import UndoIcon from '@mui/icons-material/Undo';
import { useTranslation } from 'react-i18next';
import { useRoleplay } from '../hooks/use-roleplay.js';
import { getAppUrl } from '../routes.js';

let _ = t => t,
  _t;
const StackBgWhite = styled(Stack)(_t || (_t = _`
  &::before {
    position: absolute;
    inset: 0;
    background: #fff;
    width: 100%;
    height: calc(100%);
    content: '';
    z-index: -1;
    display: block;
  }
`));
const RoleplayModeAlert = () => {
  const {
    palette
  } = useUtility();
  const {
    t
  } = useTranslation();
  const {
    isRoleplay,
    signOut,
    signOutLoading
  } = useRoleplay();
  if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
    return jsx(Fragment, {});
  }
  const handleSignout = () => __awaiter(void 0, void 0, void 0, function* () {
    if (typeof window === 'undefined' || typeof window.navigator === 'undefined') return;
    yield signOut();
    window.location.href = getAppUrl('/roleplay');
  });
  if (!isRoleplay) {
    return null;
  }
  return jsx(StackBgWhite, Object.assign({
    width: "100vw",
    bgcolor: palette('surfaceAt4'),
    py: 2,
    borderBottom: 1.5,
    borderColor: palette('surfaceVariant'),
    position: "relative"
  }, {
    children: jsx(Container, Object.assign({
      maxWidth: "xl"
    }, {
      children: jsxs(Stack, Object.assign({
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between"
      }, {
        children: [jsxs(Stack, Object.assign({
          direction: "row",
          alignItems: "center",
          gap: 2
        }, {
          children: [jsx(InfoIcon, {
            sx: {
              color: palette('onSurface')
            }
          }), jsx(Text, Object.assign({
            color: 'onSurface'
          }, {
            children: t('roleplayModeAlert.title')
          }))]
        })), jsx(Button, Object.assign({
          variant: "text",
          startIcon: jsx(UndoIcon, {}),
          onClick: handleSignout,
          loading: signOutLoading
        }, {
          children: t('roleplayModeAlert.button')
        }))]
      }))
    }))
  }));
};

export { RoleplayModeAlert };
